<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dax40R/tc-custom/9781446381106.jpg?1703709013930" alt="This image is the cover for the book Bag for All Reasons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bag for All Reasons
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of the bestselling <i>The Bag Making Bible</i> comes a collection of twelve inspiring bags for you to make at home—includes photos.</b><br/><br/>Lisa Lam brings you a stunning collection of sewing patterns to make your own bags. The book features twelve bag designs with full photographic instructions, as well as a link to print-at-home patterns so that you can get started right away.<br/><br/><i>A Bag for All Reasons </i>is filled with Lisa’s in-depth advice, from the tools and equipment you need, to understanding and interpreting patterns, to choosing, preparing and cutting fabrics. A comprehensive techniques section explains some core bag-making techniques such as how to insert a zip pocket and how to use magnetic snap closures—everything you need to create professional, practical and great-looking bags. <br/><br/>With projects ranging in complexity from the beginner Compact Groceries Tote to the more fully featured Too-Cool-for-School Satchel, you can progress with each new creation. You can make your own iPad case, sew a child’s backpack, create a pretty purse using a metal purse frame, and so much more! The bags all have style and substance and are designed with real-life practical uses in mind. Within each project Lisa gives her hints and tips for success, along with advice on how you can customize the patterns to create your own version of the design.<br/><br/>“Lisa has created another, spirited collection of gorgeous bags that are fashionable with an added higher purpose of being incredibly useful! This information rich book will elevate your sewing know how with versatile techniques and inspiring suggestions for making these bags your own.” —Amy Butler, author of “Style Stitches” <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Lam
      </h2>
      
      <p class="authorDescription body article">Lisa Lam is a London College of Fashion graduate and the founder and owner of U-Handbag.com. She is a prolific bag designer and regular contributor to craft magazines. Lisa's blog is followed by thousands of crafters who admire both her passion and the quality of her bag-making advice. Lisa lives in Brighton, UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A David and Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74e84849